import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useParams, useNavigate } from 'react-router-dom';

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from "@fortawesome/free-solid-svg-icons";

export default function NoticeView() {

  const navigate = useNavigate();

  const { param } = useParams();
  const [roleCheck, setRoleCheck] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState({
    writer: '',
    title: '',
    content: '',
    file: null,
    published: 0,
  });

  useEffect(() => {
    // 서버에서 게시글 데이터 가져오는 로직
    async function selectNoticeById() {

      //console.log("select param id : " + param);

      try {
        //로딩중 표기
        setIsLoading(true);

        const response = await axios.get(`/notice/selectNoticeById?id=${param}`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        });

        const data = response.data;

        //console.log(data);

        //console.log("Posts Return : " + JSON.stringify(data.result));

        // console.log("Role Check Result : " + data.userRole);
        
        setRoleCheck(data.userRole);

        // 접근 사용자 권한 체크
        // if(data.userRole !== "") {

          // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
          setIsLoading(false);

          setFormData({
            id : data.result.id,
            writer : data.result.writer,
            title : data.result.title,
            content : data.result.content,
            filename : data.result.file_o_name,
            filepath : data.result.file_path + data.result.file_c_name,
            published : data.result.published
          })

        // } else {
        //   //로그인이 안된 상태인 경우, 로그인 페이지로 안내
        //   alert("해당 메뉴는 로그인 후에 사용 가능합니다. 로그인 페이지로 이동합니다.");
        //   navigate("/Login");
        // }

      } catch (error) {
        console.error('게시글 조회 오류:', error);
      }
    }

    selectNoticeById();
  }, []);

  /*
  const fileDownload = async (e) => {
    e.preventDefault();

    try {
      await axios.get(`/board/file?file=${formData.filepath}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      });
    } catch (error) {
      console.error('파일 다운로드 오류:', error);
    }
  }
  */

  const goBack = (e) => {
    e.preventDefault();
    
    navigate("/Notice");
  }

  const goModify = (e) => {
    e.preventDefault();

    navigate(`/NoticeUpdate/${param}`);
  }

  const goDelete = async (e) => {
    e.preventDefault();

    //console.log("delete param id : " + param);

    try {
      const response = await axios.get(`/notice/deleteNoticeById?id=${param}`,
      { baseURL : process.env.REACT_APP_SERVER_URL },
      {
        withCredentials: true
      });

      //console.log(response);

      const data = response.data;
      //console.log(data);
      const messages = data.messages;

      // 성공 메세지 표출
      if (messages && messages.success) {
        alert(messages.success);
        // 성공 후 페이지 이동
        return navigate("/Notice");
      }

    } catch (error) {
      console.error('게시글 삭제 오류:', error);
    }
  }

  return (
    <>
    <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="Notice" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Notice</div>
                    <div className="SectionHeaderTitle">공지사항</div>
                    <div className="SectionHeaderDescription">
                      LONE-Smart 관련 공지사항을 제공합니다
                    </div>
                    </div>
                </div>

                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {isLoading &&
                          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    }
                    <div className="form-control">
                    <form>
                        <div className="form-box">
                            <div className="form-label">작성자</div>
                            <input
                            className="form-result"
                            id="writer" 
                            name="writer"
                            value={formData.writer}
                            disabled/>
                        </div>
                        <div className="form-box">
                        <label htmlFor="title">
                            <div className="form-label">제목</div>
                            <input
                            type="text"
                            className="form-result"
                            id="title" 
                            name="title"
                            value={formData.title}
                            disabled/>
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="content">
                            <div className="form-label">내용</div>
                            <textarea 
                            className="form-result-area"
                            id="content"
                            name="content" 
                            value={formData.content}
                            disabled />
                        </label>
                        </div>

                        {formData.filename &&
                        <div className="form-box">
                        <label htmlFor="file">
                            <div className="form-label">첨부파일&nbsp;</div>
                            {/* <a href={new URL(`/notice/file?file=${formData.filepath}`, process.env.REACT_APP_SERVER_URL).toString()}
                              download={formData.filename}> */}
                                {/* <a href={`${process.env.REACT_APP_SERVER_URL}/board/file?file=${encodeURIComponent(formData.filepath)}`}
   download={formData.filename}> */}
     <a href={`https://intospace.co.kr/notice/file?file=${(formData.filepath)}`}
   download={formData.filename}>
                                    <div className="form-result-file-box">
                                      <FontAwesomeIcon icon={faFile} style={{color:'lightgray'}}/> &nbsp;
                                      <span 
                                      className="form-result-file"
                                      id="file" 
                                      name="file">
                                        {formData.filename}

                                      </span>
                                    </div>
                                </a>
                        </label>
                        </div>
                        }

                        {roleCheck && roleCheck === "admin" ? (
                        <div className="form-box">
                        <label htmlFor="published">
                            <div className="form-label">공개여부</div>
                            <span className="form-result-file">{formData.published === '1' ? ("공개") : ("비공개")}</span>
                        </label>
                        </div>
                        ) : (<></>)}

                        <div className="board-view-button-area">
                          <button className="form-button-sm itsBtnGray" onClick={goBack}>이전</button>
                          {roleCheck && roleCheck === "admin" ? (
                          <div className="board-view-modify-area">
                            <button className="form-button-sm" onClick={goModify}>수정</button>
                            <button className="form-button-sm" onClick={goDelete}>삭제</button>
                          </div>
                          ) : (<></>)}
                        </div>
                    </form>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer />
    </>
  );
}